import request from '../../../../../../helpers/request';
import { message } from 'antd';
import { client } from '../../../../../../actions';
import { authHeader } from '../../../../../../helpers/auth-header';
import { createBlobFileFromResponse } from '../../lib/file';

export const importClients = ({ houseId, data }) =>
  request.put(
    `/HousingStock/house/${houseId}/import_clients`,
    data,
    'Не удалось сохранить собственников',
    'Error'
  );

export const importPersonalAccounts = ({ houseId, items }) =>
  request.post(
    `/HousingStock/account/import`,
    { houseId, items },
    'Не удалось сохранить лицевые счета',
    'Error'
  );

const getResponseData = async (responseData) => {
  if (!responseData) return undefined;

  if (!(responseData instanceof Blob)) {
    if (typeof responseData !== 'string') return responseData;

    try {
      return JSON.parse(responseData);
    } catch (_error) {
      return responseData;
    }
  }

  if (!responseData.size) return undefined;

  const text = await responseData.text();
  if (!text) return undefined;

  try {
    return JSON.parse(text);
  } catch (_error) {
    return text;
  }
};

const getBackendErrorMessage = (data) =>
  typeof data === 'string' ? data : data?.message;

export const importPersonalAccountsByCompanies = async ({
  companyId,
  accountTypeId,
  items,
}) => {
  try {
    const response = await client.post(
      '/HousingStock/account/import_by_companies',
      { companyId, accountTypeId, items },
      {
        headers: authHeader(),
        responseType: 'blob',
      }
    );

    const errorFile = createBlobFileFromResponse({
      response,
      fallbackName: 'Ошибки импорта лицевых счетов по УК.xlsx',
    });

    if (errorFile) return { errorFile };

    const data = await getResponseData(response.data);

    if (data?.result === 'Error') {
      message.error(getBackendErrorMessage(data));
      return 'Error';
    }

    return data;
  } catch (error) {
    const errorFile = createBlobFileFromResponse({
      response: error.response,
      fallbackName: 'Ошибки импорта лицевых счетов по УК.xlsx',
    });

    if (errorFile) return { errorFile };

    const data = await getResponseData(error.response?.data);
    const errorMessage = getBackendErrorMessage(data);

    if (error.response?.status !== 401) {
      message.error(errorMessage || 'Не удалось загрузить лицевые счета по УК');
    }

    return 'Error';
  }
};

export const importIndividualMeters = ({ houseId, items }) =>
  request.post(
    `/Meter/import`,
    { houseId, items },
    'Не удалось сохранить ИПУ',
    'Error'
  );
